module.exports = __webpack_public_path__ + "img/type_container-chassis_gooseneck.3272db26.jpg";